<template>
    <div>
        <header class="panel__header">
            <h2 class="panel__title">Profile</h2>
        </header>
        <form @submit.prevent="save" v-if="user" action="#" class="form form--grid">
            <div class="form__group">
                <label for="first_name" class="form__label">First Name</label>
                <input v-model="form.first_name" id="first_name" type="text" class="lc-first form__input" :class="{ 'form__input--error' : form.errors.has('first_name') }">
                <span v-if="form.errors.has('first_name')" class="form__help form__help--error">{{ form.errors.get('first_name') }}</span>
            </div>
            <div class="form__group">
                <label for="last_name" class="form__label">Last Name</label>
                <input v-model="form.last_name" id="last_name" type="text" class="lc-last form__input" :class="{ 'form__input--error' : form.errors.has('last_name') }">
                <span v-if="form.errors.has('last_name')" class="form__help form__help--error">{{ form.errors.get('last_name') }}</span>
            </div>
            <div class="form__group">
                <label for="display_name" class="form__label">Display Name</label>
                <input v-model="form.display_name" id="display_name" type="text" class="lc-display form__input" :class="{ 'form__input--error' : form.errors.has('display_name') }">
                <span v-if="form.errors.has('display_name')" class="form__help form__help--error">{{ form.errors.get('display_name') }}</span>
            </div>
            <footer class="form__footer">
                <button type="submit" class="lc-save button button--primary" :disabled="form.busy">Save</button>
            </footer>
        </form>
    </div>
</template>

<script>
/* global EventBus */
import { mapState } from 'vuex'
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            form: new Form({
                first_name: '',
                last_name: '',
                display_name: ''
            })
        }
    },

    watch: {
        user: {
            immediate: true,
            handler (newUser) {
                if (newUser.id) {
                    this.hydrateForm()
                }
            }
        }
    },

    methods: {
        hydrateForm () {
            this.form.first_name = this.user.first_name
            this.form.last_name = this.user.last_name
            this.form.display_name = this.user.display_name
        },

        save () {
            this.$store.dispatch('users/saveUserProfile', this.form).then(() => {
                EventBus.$emit('newSnackbar', `Your profile was updated`)
            })
        }
    },

    computed: {
        ...mapState('users', {
            user: 'current'
        })
    }
}
</script>
